var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradientPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1231.698,
    height: 1280.854,
    viewBox: "0 0 1231.698 1280.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 1.006,
    gradientTransform: "matrix(0.385, -0.923, 0.515, 0.215, 0.05, 0.854)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#672784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#642680",
    stopOpacity: 0.973
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303",
    stopOpacity: 0.102
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M296,0c64.737,0,263.4-81.5,312.417-67.363C682.434-46.011,592,78.638,592,118c0,65.17-132.524,118-296,118S0,183.17,0,118,132.524,0,296,0Z",
    transform: "translate(350.354 835.612) rotate(-51)",
    fill: "url(#radial-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientPurple);
export default __webpack_public_path__ + "static/media/gradient-purple.81a9f73b77f8b763791f7e153da73621.svg";
export { ForwardRef as ReactComponent };